import React from 'react';
import { faPhone } from '@fortawesome/free-solid-svg-icons/faPhone';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  AnyQuestionsSectionCustomisation,
  OpeningHoursCustomisation
} from '../../../common/CommonTypes';
import { useTranslation } from 'react-i18next';

export type AnyQuestionsSectionProps = {
  cms: AnyQuestionsSectionCustomisation;
};

const AnyQuestionsSection = ({
  cms
}: AnyQuestionsSectionProps): JSX.Element => {
  const { t } = useTranslation();
  const callusText = t('landing-page.callus-text');
  const emailUsText = t('landing-page.email-us-text');
  const getEmailRef = () => {
    let email = '';

    if (cms.landingPageQuestionsSectionEmail) {
      email = 'mailto:' + cms.landingPageQuestionsSectionEmail;
    }

    return email;
  };

  const getPhoneRef = () => {
    let phone = '';

    if (cms.landingPageQuestionsSectionNumber) {
      phone = 'tel:' + cms.landingPageQuestionsSectionNumber;
    }

    return phone;
  };

  const renderOpeningHours = () => {
    if (cms.openingHours && cms.openingHours.length > 0) {
      return cms.openingHours.map((item: OpeningHoursCustomisation, i) => (
        <p key={`opening-hours-${i}`} className='p1 extra-line-height'>
          <span>
            {item.openingDays}, {item.openingTimes}
          </span>{' '}
          <span className='p3'>({item.availableServices})</span>
        </p>
      ));
    }
  };

  return (
    <div className='flex-column landing-page--questions m4-top m4-bottom'>
      <h3 className='m2-bottom'>{cms.landingPageQuestionsSectionHeader}</h3>
      <p className='p1 extra-line-height m2-bottom'>
        {cms.landingPageQuestionsSectionDescription}
      </p>
      <div className='m2-bottom'>{renderOpeningHours()}</div>
      <div className='landing-page--question-contact mobile-column'>
        <div>
          <FontAwesomeIcon
            icon={faPhone}
            rotation={90}
            className='primary-color m05-right cms-renewal-phone-icon'
          />
          <span className='m2-right'>
            {callusText}
            <a href={getPhoneRef()}>
              <span className='underline-text'>
                {cms.landingPageQuestionsSectionNumber}
              </span>
            </a>
          </span>
        </div>
        <div>
          <FontAwesomeIcon
            icon={faEnvelope}
            className='primary-color m05-right cms-renewal-email-icon'
          />
          <span className='m2-right'>
            {emailUsText}
            <span className='underline-text'>
              <a href={getEmailRef()}>{cms.landingPageQuestionsSectionEmail}</a>
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default AnyQuestionsSection;
